import { Property } from "../types/property-types";
import { getProperty } from "../data/properties/property-fetcher";

export const PROPERTY_CARD_NO_PRICE_FIRST_TEXT =
  "Contact the community for more";
export const PROPERTY_CARD_NO_PRICE_SECOND_TEXT =
  "information on price and availability";

/**
 * Retrieves a property by parsing the request path.
 *
 * The format of the request path for a property details page is expected to be
 * `/{propertyName}-{propertyLocation}/p_{propertyId}`.
 *
 * @param requestPath - An array of strings representing the request path.
 * @returns A promise that resolves to the property if found, or null if the request path is invalid or the property is not found.
 */
export const getPropertyByRequestPath = async (
  requestPath: string[]
): Promise<Property | null> => {
  // The format of the request path for a property details page is expected to be /{propertyName}-{propertyLocation}/p_{propertyId}/fees|gallery
  if (requestPath.length < 2) {
    return null;
  }

  let id = requestPath[1];

  if (id.startsWith("p_")) {
    id = id.substring(2);
  }

  return await getProperty(id);
};

/**
 * Formats a number into a currency string with a currency symbol and commas for thousands.
 *
 * @param amount - The number to format.
 * @param currencySymbol - The currency symbol to use.
 * @returns The formatted currency string.
 */
export const formatCurrency = (
  amount: number,
  currencySymbol: string,
  fractionDigits?: number
): string => {
  return `${currencySymbol}${amount.toLocaleString("en-US", { minimumFractionDigits: fractionDigits ?? 0, maximumFractionDigits: fractionDigits ?? 0 })}`;
};
